import { Component, Input } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Router } from '@angular/router';
import { SmartDevicesService } from '@app/modules/smart-devices/service/smart-devices.service';
import { NotificationType } from '@app/shared/interfaces';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { sbnbIcon } from '@app/ui';
import { ThermostatPreset } from '../../data/smart-devices.interface';

@Component({
  selector: 'sbnb-smart-device-thermostat-presets-table',
  templateUrl: './smart-device-thermostat-presets-table.component.html',
  styleUrls: ['./smart-device-thermostat-presets-table.component.scss'],
})
export class SmartDeviceThermostatPresetsTableComponent {
  isMobile$ = this.deviceService.isMobileViewport();
  displayedColumns = ['image', 'name', 'set-points', 'fan', 'preset-type', 'thermostats'];
  loading = false;

  @Input() presets: ThermostatPreset[];
  @Input() canAction = true;

  constructor(
    private deviceService: DeviceDetectionService,
    private smartService: SmartDevicesService,
    private toast: ToastNotificationsService,
    private router: Router
  ) {}

  getPresetType(key: string): string {
    switch (key) {
      case 'occupied':
        return 'Occupied';
      case 'unoccupied':
        return 'Unoccupied';
      case 'long-term-unoccupied':
        return 'Long-term Unoccupied';
      default:
        return 'Unknown';
    }
  }

  getPresetIcon(key: string): sbnbIcon {
    switch (key) {
      case 'occupied':
        return 'occupied';
      case 'unoccupied':
        return 'unoccupied';
      case 'long-term-unoccupied':
        return 'long-term-unoccupied';
      default:
        return null;
    }
  }

  activateOrDeactivateThermostatPreset(preset, event: MatSlideToggleChange) {
    preset.is_active = event.checked;

    this.smartService.activeOrDeactivateThermostatPreset(preset.id, preset.is_active).subscribe((res: any) => {
      if (res.success) {
        return;
      }

      if (res.error) {
        preset.is_active = !preset.is_active;

        this.toast.open(`Oops! We ran into an error updating the Thermostat preset`, 'Dismiss', NotificationType.Error);
      }
    });
  }

  openPreset(row) {
    this.router.navigate(['/devices/thermostat-presets', row.id]);
  }
}
